const Device = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 12 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="path-1-inside-1_9075_1402"
      fill="white"
    >
      <rect
        width="12"
        height="14.8235"
        rx="0.714286"
      />
    </mask>
    <rect
      width="12"
      height="14.8235"
      rx="0.714286"
      stroke="#546E7A"
      strokeWidth="2.2"
      mask="url(#path-1-inside-1_9075_1402)"
    />
    <mask
      id="path-2-inside-2_9075_1402"
      fill="white"
    >
      <rect
        x="4"
        y="9.17651"
        width="4"
        height="1.85714"
        rx="0.285714"
      />
    </mask>
    <rect
      x="4"
      y="9.17651"
      width="4"
      height="1.85714"
      rx="0.285714"
      stroke="#546E7A"
      strokeWidth="1.85714"
      mask="url(#path-2-inside-2_9075_1402)"
    />
    <rect
      x="0.0714286"
      y="-0.0714286"
      width="0.571429"
      height="0.142857"
      transform="matrix(1 0 0 -1 5.57129 11.7397)"
      stroke="#546E7A"
      strokeWidth="0.142857"
    />
    <rect
      x="0.0714286"
      y="-0.0714286"
      width="0.571429"
      height="0.142857"
      transform="matrix(1 0 0 -1 6.42871 12.311)"
      stroke="#546E7A"
      strokeWidth="0.142857"
    />
    <rect
      x="0.0714286"
      y="-0.0714286"
      width="0.571429"
      height="0.142857"
      transform="matrix(1 0 0 -1 4.71387 12.311)"
      stroke="#546E7A"
      strokeWidth="0.142857"
    />
    <rect
      x="0.0714286"
      y="-0.0714286"
      width="0.571429"
      height="0.142857"
      transform="matrix(1 0 0 -1 5.57129 12.8823)"
      stroke="#546E7A"
      strokeWidth="0.142857"
    />
    <rect
      x="10.2473"
      y="12.3655"
      width="0.714286"
      height="0.714286"
      rx="0.357143"
      transform="rotate(180 10.2473 12.3655)"
      stroke="#546E7A"
      strokeWidth="0.714286"
    />
    <line
      y1="7.76104"
      x2="12"
      y2="7.76103"
      stroke="#546E7A"
      strokeWidth="1.1"
    />
    <line
      x1="1.61211"
      y1="14.1597"
      x2="1.61211"
      y2="16.1597"
      stroke="#546E7A"
      strokeWidth="0.4"
    />
    <line
      x1="2.12285"
      y1="14.1597"
      x2="2.12285"
      y2="16.1597"
      stroke="#546E7A"
      strokeWidth="0.4"
    />
    <line
      x1="3.48711"
      y1="14.1597"
      x2="3.48711"
      y2="16.1597"
      stroke="#546E7A"
      strokeWidth="0.4"
    />
    <line
      x1="3.99785"
      y1="14.1597"
      x2="3.99785"
      y2="16.1597"
      stroke="#546E7A"
      strokeWidth="0.4"
    />
    <line
      x1="8.25859"
      y1="14.1597"
      x2="8.25859"
      y2="16.1597"
      stroke="#546E7A"
      strokeWidth="0.4"
    />
    <line
      x1="8.77031"
      y1="14.1597"
      x2="8.77031"
      y2="16.1597"
      stroke="#546E7A"
      strokeWidth="0.4"
    />
    <line
      x1="10.1336"
      y1="14.1597"
      x2="10.1336"
      y2="16.1597"
      stroke="#546E7A"
      strokeWidth="0.4"
    />
    <line
      x1="10.6453"
      y1="14.1597"
      x2="10.6453"
      y2="16.1597"
      stroke="#546E7A"
      strokeWidth="0.4"
    />
  </svg>
);

export default Device;
